(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  href: _propTypes.string,
  info: _propTypes.string,
  text: _propTypes.string.isRequired,
  type: _propTypes.string,
  size: _propTypes.string,
  theme: _propTypes.string,
  outline: _propTypes.bool,
  cssClass: _propTypes.string,
  handleClick: _propTypes.func
};

// ImageCTA is a stateless functional component.
var Button = function Button(props) {
  var href = props.href,
    info = props.info,
    text = props.text,
    _props$type = props.type,
    type = _props$type === void 0 ? "button" : _props$type,
    size = props.size,
    theme = props.theme,
    _props$outline = props.outline,
    outline = _props$outline === void 0 ? false : _props$outline,
    _props$cssClass = props.cssClass,
    cssClass = _props$cssClass === void 0 ? "" : _props$cssClass,
    handleClick = props.handleClick;
  var buttonSize = size ? "hl__button--".concat(size) : "";
  var buttonStyle = outline ? "hl__button--minor" : "";
  var buttonTheme = theme ? "hl__button--".concat(theme) : "";
  var buttonClass = "hl__button ".concat(buttonSize, " ").concat(buttonTheme, " ").concat(buttonStyle, " ").concat(cssClass);
  if (href) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: href,
      className: buttonClass,
      title: info
    }, text);
  } else {
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: type,
      className: buttonClass,
      "aria-label": info,
      onClick: handleClick
    }, text);
  }
};
Button.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = Button;

},{"prop-types":"prop-types","react":"react"}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  checked: _propTypes.bool.isRequired,
  icon: _propTypes.string,
  inline: _propTypes.bool,
  label: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired,
  onChange: _propTypes.func.isRequired,
  subLabel: _propTypes.string,
  theme: _propTypes.string,
  value: _propTypes.string.isRequired
};
var CheckboxFilter = function CheckboxFilter(props) {
  var handleChange = function handleChange(event) {
    props.onChange(event);
  };
  var name = props.name,
    value = props.value,
    label = props.label,
    _props$subLabel = props.subLabel,
    subLabel = _props$subLabel === void 0 ? "" : _props$subLabel,
    checked = props.checked,
    icon = props.icon,
    inline = props.inline,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? "dark" : _props$theme;
  var inlineClass = inline ? "hl__checkbox-filter--inline" : "";
  var themeClass = theme ? "hl__checkbox-filter--".concat(theme) : "";
  return /*#__PURE__*/_react["default"].createElement("label", {
    className: "hl__checkbox-filter ".concat(themeClass, " ").concat(inlineClass)
  }, /*#__PURE__*/_react["default"].createElement("input", {
    name: name,
    type: "checkbox",
    value: value,
    checked: checked,
    onChange: handleChange,
    className: "hl__checkbox-filter__label"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__checkbox-filter__container"
  }, icon && !inline && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__checkbox-filter__icon"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: icon,
    alt: ""
  })), icon && inline && /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    src: icon,
    className: "hl__checkbox-filter__icon"
  }), subLabel === "" && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__checkbox-filter__label"
  }, label), subLabel !== "" && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__checkbox-filter__label"
  }, label, " \u2014 ", /*#__PURE__*/_react["default"].createElement("small", null, subLabel))));
};
CheckboxFilter.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = CheckboxFilter;

},{"prop-types":"prop-types","react":"react","react-inlinesvg":"react-inlinesvg"}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  align: _propTypes.string,
  alt: _propTypes.string,
  src: _propTypes.string.isRequired,
  height: _propTypes.string,
  width: _propTypes.string
};
var Image = function Image(props) {
  var align = props.align,
    alt = props.alt,
    src = props.src,
    height = props.height,
    width = props.width;
  var imageAlign = align ? "hl__image--".concat(align) : "";
  return /*#__PURE__*/_react["default"].createElement("img", {
    className: "hl__image".concat(imageAlign),
    alt: alt,
    src: src,
    height: height,
    width: width
  });
};
Image.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = Image;

},{"prop-types":"prop-types","react":"react"}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  fill: _propTypes.string,
  width: _propTypes.string,
  height: _propTypes.string,
  viewBox: _propTypes.string
};
var GridSVG = function GridSVG(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "mask0_4901_182995",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "24",
    height: "24",
    fill: "#D9D9D9"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    mask: "url(#mask0_4901_182995)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3 11V3H11V11H3ZM3 21V13H11V21H3ZM13 11V3H21V11H13ZM13 21V13H21V21H13ZM5 9H9V5H5V9ZM15 9H19V5H15V9ZM15 19H19V15H15V19ZM5 19H9V15H5V19Z",
    fill: "#363636"
  })));
};
GridSVG.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = GridSVG;

},{"prop-types":"prop-types","react":"react","react-dom":"react-dom"}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  iconName: _propTypes.string,
  fill: _propTypes.string,
  width: _propTypes.string,
  height: _propTypes.string,
  viewBox: _propTypes.string
};
var GiftSVG = function GiftSVG(props) {
  // const iconClass = iconName ? `hl__icon--${iconName}` : "";
  var iconClass = "hl__icon--gift";
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__icon ".concat(iconClass)
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#363636"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-879.000000, -680.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(0.000000, 598.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(879.000000, 82.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19,5 L16.2,5 C16.7,4.5 17,3.8 17,3 C17,1.3 15.7,0 14,0 C13,0 11.2,0.9 10,2.1 C8.8,0.9 7,0 6,0 C4.3,0 3,1.3 3,3 C3,3.8 3.3,4.5 3.8,5 L1,5 C0.4,5 0,5.4 0,6 L0,8.8 C0,8.9 0.1,9 0.2,9 L8.6,9 C8.8,9 9,8.8 9,8.6 L9,5.4 C9,5.2 9.2,5 9.4,5 L10.6,5 C10.8,5 11,5.2 11,5.4 L11,8.6 C11,8.8 11.2,9 11.4,9 L19.8,9 C19.9,9 20,8.9 20,8.8 L20,6 C20,5.4 19.6,5 19,5 Z M6,4 C5.4,4 5,3.6 5,3 C5,2.4 5.4,2 6,2 C6.6,2 8.4,3.2 8.9,3.8 C8.6,3.9 6,4 6,4 Z M14,4 C14,4 11.4,3.9 11.1,3.8 C11.7,3.1 13.4,2 14,2 C14.6,2 15,2.4 15,3 C15,3.6 14.6,4 14,4 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.6,11 L1.2,11 C1.1,11 1,11.1 1,11.2 L1,19 C1,19.6 1.4,20 2,20 L8.6,20 C8.8,20 9,19.8 9,19.6 L9,11.4 C9,11.2 8.8,11 8.6,11 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.8,11 L11.4,11 C11.2,11 11,11.2 11,11.4 L11,19.6 C11,19.8 11.2,20 11.4,20 L18,20 C18.6,20 19,19.6 19,19 L19,11.2 C19,11.1 18.9,11 18.8,11 Z"
  }))))));
};
GiftSVG.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = GiftSVG;

},{"prop-types":"prop-types","react":"react","react-dom":"react-dom"}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  fill: _propTypes.string,
  width: _propTypes.string,
  height: _propTypes.string,
  viewBox: _propTypes.string
};
var ListSVG = function ListSVG(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "mask0_4901_183085",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "24",
    height: "24",
    fill: "#D9D9D9"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    mask: "url(#mask0_4901_183085)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3 22V20H21V22H3ZM3 16V14H21V16H3ZM3 10V8H21V10H3ZM3 4V2H21V4H3Z",
    fill: "#EFE8E1"
  })));
};
ListSVG.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = ListSVG;

},{"prop-types":"prop-types","react":"react","react-dom":"react-dom"}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  fill: _propTypes.string,
  width: _propTypes.string,
  height: _propTypes.string,
  viewBox: _propTypes.string
};
var MasonrySVG = function MasonrySVG(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#f9f9f9"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1468 -653)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1468 666v-13h11v13zm0 11v-8h11v8zm13 0v-13h11v13zm0-24h11v8h-11z"
  }))));
};
MasonrySVG.propTypes = propTypes; // defined at top of the filter
var _default = exports["default"] = MasonrySVG;

},{"prop-types":"prop-types","react":"react","react-dom":"react-dom"}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  fill: _propTypes.string,
  width: _propTypes.string,
  height: _propTypes.string,
  viewBox: _propTypes.string
};
var SingleListSVG = function SingleListSVG(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#f9f9f9"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1468.000000, -661.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(0.000000, 597.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1455.000000, 53.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.9090909,25 L37,25 L37,28 L29.9090909,28 L13,28 L13,25 L29.9090909,25 Z M31.9090909,32 L36.9090909,32 L36.9090909,35 L31.9090909,35 L13,35 L13,32 L31.9090909,32 Z M28.9090909,18 L37,18 L37,21 L28.9090909,21 L13,21 L13,18 L28.9090909,18 Z M26.9090909,11 L37,11 L37,14 L26.9090909,14 L13,14 L13,11 L26.9090909,11 Z"
  })))));
};
SingleListSVG.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = SingleListSVG;

},{"prop-types":"prop-types","react":"react","react-dom":"react-dom"}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
var _react = _interopRequireWildcard(require("react"));
var _checkboxFilter = _interopRequireDefault(require("../../01-atoms/forms/checkbox-filter.jsx"));
var _weekPicker = _interopRequireDefault(require("../../02-molecules/forms/week-picker.jsx"));
var _reactPicky = require("react-picky");
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FilterBarGroup = exports["default"] = /*#__PURE__*/function (_Component) {
  function FilterBarGroup() {
    var _this;
    _classCallCheck(this, FilterBarGroup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FilterBarGroup, [].concat(args));
    _defineProperty(_this, "handleAccordion", function (e) {
      e.preventDefault();
      _this.props.accordionChange(_this.props.param, !_this.props.expanded);
    });
    _defineProperty(_this, "handleSelectChange", function (value) {
      var _this$props = _this.props,
        param = _this$props.param,
        onChange = _this$props.onChange;
      onChange(param, value);
    });
    return _this;
  }
  _inherits(FilterBarGroup, _Component);
  return _createClass(FilterBarGroup, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.expanded == nextProps.expanded) {
        return;
      }
      var $content = (0, _jquery["default"])(this.accordionContent);
      if (nextProps.expanded) {
        $content.slideDown();
      } else {
        $content.slideUp();
      }
    }
  }, {
    key: "renderFilters",
    value: function renderFilters() {
      var _this$props2 = this.props,
        _this$props2$assetsUr = _this$props2.assetsUrl,
        assetsUrl = _this$props2$assetsUr === void 0 ? "../.." : _this$props2$assetsUr,
        param = _this$props2.param,
        onChange = _this$props2.onChange,
        filterType = _this$props2.filterType,
        _this$props2$selected = _this$props2.selected,
        selected = _this$props2$selected === void 0 ? [] : _this$props2$selected,
        items = _this$props2.items,
        placeholder = _this$props2.placeholder,
        label = _this$props2.label;
      switch (filterType) {
        case "checkbox":
          return items.map(function (item, index) {
            return /*#__PURE__*/_react["default"].createElement(_checkboxFilter["default"], _extends({
              key: param + item.value,
              onChange: onChange,
              name: param
            }, item));
          });
          break;
        case "select":
          return /*#__PURE__*/_react["default"].createElement(_reactPicky.Picky, {
            id: param,
            value: selected,
            name: param,
            options: items,
            multiple: true,
            includeSelectAll: false,
            includeFilter: false,
            onChange: this.handleSelectChange,
            dropdownHeight: 200,
            valueKey: 'value',
            labelKey: 'label',
            numberDisplayed: 0,
            placeholder: placeholder,
            manySelectedPlaceholder: placeholder + " (%s)"
          });
          break;
        case "keyword":
          return /*#__PURE__*/_react["default"].createElement("input", {
            className: "hl__input",
            "aria-label": label,
            name: param,
            id: param,
            type: "search",
            placeholder: placeholder,
            value: items.length && items[0].value ? items[0].value : "",
            onChange: onChange
          });
          break;
        case "weekPicker":
          return items.map(function (item, index) {
            return /*#__PURE__*/_react["default"].createElement(_weekPicker["default"], _extends({
              key: "single_date_".concat(index),
              assetsUrl: assetsUrl,
              onDateChange: onChange
            }, item));
          });
          break;
        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        label = _this$props3.label,
        expanded = _this$props3.expanded,
        filterType = _this$props3.filterType,
        hideAccordion = _this$props3.hideAccordion,
        accordionChange = _this$props3.accordionChange;
      var themeClass = filterType === "inline-checkbox" ? "hl__filter-bar-group--inline" : "";
      return /*#__PURE__*/_react["default"].createElement("fieldset", {
        className: "hl__filter-bar-group ".concat(themeClass)
      }, !hideAccordion && accordionChange && /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("button", {
        className: "hl__filter-bar-group__label",
        type: "button",
        "aria-expanded": expanded,
        onClick: this.handleAccordion
      }, label)), hideAccordion && /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar-group__label"
      }, label)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar-group__items",
        ref: function ref(el) {
          return _this2.accordionContent = el;
        }
      }, this.renderFilters()));
    }
  }]);
}(_react.Component);
_defineProperty(FilterBarGroup, "propTypes", {
  accordionChange: _propTypes.func,
  assetsUrl: _propTypes.string,
  expanded: _propTypes.bool.isRequired,
  filterType: _propTypes.string.isRequired,
  hideAccordion: _propTypes.bool,
  items: _propTypes.array.isRequired,
  label: _propTypes.string,
  onChange: _propTypes.func.isRequired,
  param: _propTypes.string.isRequired,
  placeholder: _propTypes.string,
  selected: _propTypes.array // for select type
});

},{"../../01-atoms/forms/checkbox-filter.jsx":2,"../../02-molecules/forms/week-picker.jsx":13,"jquery":"jquery","prop-types":"prop-types","react":"react","react-picky":"react-picky"}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _filterBarGroup = _interopRequireDefault(require("./filter-bar-group.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var propTypes = {
  assetsUrl: _propTypes.string.isRequired,
  message: _propTypes.string,
  groups: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    param: _propTypes.string.isRequired,
    expanded: _propTypes.bool.isRequired,
    items: _propTypes.array
  })).isRequired,
  onClearAll: _propTypes.func,
  title: _propTypes.string.isRequired,
  theme: _propTypes.string
};
var FilterBar = function FilterBar(props) {
  var renderGroups = function renderGroups(groups) {
    var assetsUrl = props.assetsUrl;
    return groups.filter(function (group) {
      return group.items && group.items.length;
    }).map(function (group) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar__group",
        key: group.param
      }, /*#__PURE__*/_react["default"].createElement(_filterBarGroup["default"], _extends({
        assetsUrl: assetsUrl
      }, group)));
    });
  };
  var groups = props.groups,
    title = props.title,
    onClearAll = props.onClearAll,
    assetsUrl = props.assetsUrl,
    message = props.message,
    theme = props.theme;
  var themeColor = theme ? "hl__filter-bar--".concat(theme) : "";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-bar ".concat(themeColor)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-bar__container"
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: "hl__filter-bar__header"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "hl__filter-bar__title"
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-bar__filters"
  }, renderGroups(groups), message && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-bar__message"
  }, message)), onClearAll && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-bar__clear"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "hl__filter-bar__clear-button",
    type: "button",
    "aria-label": "Clear all filters",
    onClick: onClearAll
  }, "Clear All"))));
};
FilterBar.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = FilterBar;

},{"./filter-bar-group.jsx":9,"prop-types":"prop-types","react":"react"}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _svgListView = _interopRequireDefault(require("../../01-atoms/svg-icons/svg-list-view.jsx"));
var _svgSingleListView = _interopRequireDefault(require("../../01-atoms/svg-icons/svg-single-list-view.jsx"));
var _svgMasonryView = _interopRequireDefault(require("../../01-atoms/svg-icons/svg-masonry-view.jsx"));
var _svgCardView = _interopRequireDefault(require("../../01-atoms/svg-icons/svg-card-view.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  label: _propTypes.string,
  onChange: _propTypes.func.isRequired,
  activeFilter: _propTypes.string,
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    name: _propTypes.string.isRequired,
    value: _propTypes.string.isRequired,
    label: _propTypes.string.isRequired,
    icon: _propTypes.string
  })).isRequired
};
var FilterToggles = function FilterToggles(props) {
  var handleChange = function handleChange(event) {
    props.onChange(event.target.value);
  };
  var renderFilters = function renderFilters(items) {
    return items.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement("label", {
        key: item.value,
        tabIndex: "0",
        className: "hl__radio-input hl__radio-input--".concat(props.activeFilter)
      }, /*#__PURE__*/_react["default"].createElement("input", {
        name: "toggle",
        "aria-label": item.name,
        type: "radio",
        value: item.value,
        checked: item.value === props.activeFilter,
        onChange: handleChange
      }), item.icon && item.icon == "list" && /*#__PURE__*/_react["default"].createElement(_svgListView["default"], null), item.icon && item.icon == "masonry" && /*#__PURE__*/_react["default"].createElement(_svgMasonryView["default"], null), item.icon && item.icon == "single" && /*#__PURE__*/_react["default"].createElement(_svgSingleListView["default"], null), item.icon && item.icon == "grid" && /*#__PURE__*/_react["default"].createElement(_svgCardView["default"], null), /*#__PURE__*/_react["default"].createElement("span", {
        className: "hl__filter-toggles__label",
        "aria-hidden": true
      }, label));
    });
  };
  var label = props.label,
    items = props.items;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-toggles__container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-toggles"
  }, renderFilters(items)));
};
FilterToggles.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = FilterToggles;

},{"../../01-atoms/svg-icons/svg-card-view.jsx":4,"../../01-atoms/svg-icons/svg-list-view.jsx":6,"../../01-atoms/svg-icons/svg-masonry-view.jsx":7,"../../01-atoms/svg-icons/svg-single-list-view.jsx":8,"prop-types":"prop-types","react":"react"}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _svgGift = _interopRequireDefault(require("../../01-atoms/svg-icons/svg-gift.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  label: _propTypes.string,
  onChange: _propTypes.func.isRequired,
  activeFilter: _propTypes.string,
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    name: _propTypes.string.isRequired,
    value: _propTypes.string.isRequired,
    label: _propTypes.string.isRequired,
    icon: _propTypes.string
  })).isRequired
};
var SortByType = function SortByType(props) {
  var handleChange = function handleChange(event) {
    props.onChange(event.target.value);
  };
  var renderFilters = function renderFilters(items) {
    return items.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement("label", {
        key: item.value,
        className: "hl__radio-input"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        name: item.name,
        type: "radio",
        value: item.value,
        checked: item.value === props.activeFilter,
        onChange: handleChange
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "hl__radio-input__label"
      }, item.icon == "gift" && /*#__PURE__*/_react["default"].createElement(_svgGift["default"], null), item.label));
    });
  };
  var label = props.label,
    items = props.items;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__sort-by-type"
  }, /*#__PURE__*/_react["default"].createElement("fieldset", null, /*#__PURE__*/_react["default"].createElement("legend", null, label), /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__sort-by-type__label",
    "aria-hidden": true
  }, label), /*#__PURE__*/_react["default"].createElement("div", null, renderFilters(items))));
};
SortByType.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = SortByType;

},{"../../01-atoms/svg-icons/svg-gift.jsx":5,"prop-types":"prop-types","react":"react"}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("react-dates/initialize");
var _reactDates = require("react-dates");
var _moment = _interopRequireDefault(require("moment"));
var _propTypes = require("prop-types");
var _reactMomentProptypes = require("react-moment-proptypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } // https://github.com/airbnb/react-dates
var propTypes = {
  assetsUrl: _propTypes.string.isRequired,
  date: _reactMomentProptypes.momentObj.isRequired,
  focused: _propTypes.bool.isRequired,
  onFocusChange: _propTypes.func.isRequired,
  onDateChange: _propTypes.func.isRequired,
  properties: _propTypes.object,
  // optional settings
  navPrev: _propTypes.node,
  navNext: _propTypes.node
};
var WeekPicker = function WeekPicker(props) {
  var onChange = function onChange(date) {
    if (date.day() !== 0) {
      date.subtract(date.day(), "days");
    }
    props.onDateChange(date);
  };
  var onPreviousWeek = function onPreviousWeek() {
    props.onDateChange(props.date.subtract(7, "days"));
  };
  var onNextWeek = function onNextWeek() {
    props.onDateChange(props.date.add(7, "days"));
  };
  var assetsUrl = props.assetsUrl,
    properties = props.properties,
    focused = props.focused,
    date = props.date,
    onFocusChange = props.onFocusChange;
  var endDate = (0, _moment["default"])(date).add(6, "days").format("MMM DD, YYYY");
  var navPrev = /*#__PURE__*/_react["default"].createElement("svg", {
    width: "9px",
    height: "14px",
    viewBox: "0 0 9 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-733.000000, -834.000000)",
    fill: "#1E1E1E"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(690.000000, 790.000000)"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    transform: "translate(47.264520, 51.000000) scale(-1, 1) translate(-47.264520, -51.000000) ",
    points: "44.476406 58 51.2020202 51.0008077 44.476406 44 43.3270202 45.9416176 48.1873394 51.0008077 43.3270202 56.0583824"
  })))));
  var navNext = /*#__PURE__*/_react["default"].createElement("svg", {
    width: "8px",
    height: "14px",
    viewBox: "0 0 8 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-960.000000, -834.000000)",
    fill: "#1E1E1E"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(690.000000, 790.000000)"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "271.149386 58 277.875 51.0008077 271.149386 44 270 45.9416176 274.860319 51.0008077 270 56.0583824"
  })))));
  var downArrow = /*#__PURE__*/_react["default"].createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "mask0_4901_183512",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "16",
    height: "16"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "16",
    height: "16",
    fill: "#D9D9D9"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    mask: "url(#mask0_4901_183512)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.99967 11.7556L3.33301 7.08889L4.4219 6L7.99967 9.57778L11.5775 6L12.6663 7.08889L7.99967 11.7556Z",
    fill: "#A51C30"
  })));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__date-range"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__control"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    disabled: date < (0, _moment["default"])(),
    onClick: onPreviousWeek,
    type: "button",
    "aria-label": "Previous week",
    className: "hl__week-picker__control--previous"
  }, navPrev)), /*#__PURE__*/_react["default"].createElement(_reactDates.SingleDatePicker, _extends({
    date: date,
    focused: focused,
    onFocusChange: onFocusChange,
    onDateChange: onChange,
    navPrev: navPrev,
    navNext: navNext,
    showDefaultInputIcon: true,
    inputIconPosition: "after",
    customInputIcon: downArrow
  }, properties)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__week-picker__to-divider"
  }, "to"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__end-date__group"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__week-picker__end-date"
  }, endDate), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__control"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onNextWeek,
    type: "button",
    "aria-label": "Next week",
    className: "hl__week-picker__control--next"
  }, navNext)))));
};
WeekPicker.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = WeekPicker;

},{"moment":"moment","prop-types":"prop-types","react":"react","react-dates":"react-dates","react-dates/initialize":"react-dates/initialize","react-moment-proptypes":"react-moment-proptypes"}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  title: _propTypes.string.isRequired,
  image: (0, _propTypes.shape)({
    src: _propTypes.string
  }),
  link: (0, _propTypes.shape)({
    href: _propTypes.string.isRequired,
    info: _propTypes.string
  }).isRequired,
  collection_type: _propTypes.string.isRequired,
  subTitle: _propTypes.string,
  id: _propTypes.string
};
var OverlayPromo = function OverlayPromo(props) {
  var title = props.title,
    image = props.image,
    link = props.link,
    collection_type = props.collection_type,
    subTitle = props.subTitle,
    id = props.id;
  var bgImage = image && image.src ? {
    backgroundImage: "url(' ".concat(image.src, " ')")
  } : {};
  var imageClass = image && image.src ? "" : "hl__overlay-promo--no-image";
  var level = level ? level : 2;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__overlay-promo hl__clickable-card"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__overlay-promo__image ".concat(imageClass),
    style: bgImage
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__overlay-promo__details"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__overlay-promo__eyebrow"
  }, /*#__PURE__*/_react["default"].createElement("span", null, collection_type)), level == 2 && /*#__PURE__*/_react["default"].createElement("h2", {
    className: "hl__overlay-promo__title"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: link.href,
    className: "hl__clickable-card__link"
  }, title, collection_type === "website" && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__link-tag__external-icon hl__link-tag__external-icon--white"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-906 -1005)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M923.78 1022.78V1015H926v7.78c0 1.22-1 2.22-2.22 2.22h-15.56c-1.23 0-2.22-1-2.22-2.22v-15.56c0-1.22.99-2.22 2.22-2.22H916v2.22h-7.78v15.56zm-5.71-17.78H926v7.93h-2.27v-4.07L912.6 1020l-1.6-1.6 11.14-11.13h-4.07z"
  }))))))), level == 3 && /*#__PURE__*/_react["default"].createElement("h3", {
    className: "hl__overlay-promo__title"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: link.href,
    className: "hl__clickable-card__link"
  }, title, collection_type === "website" && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__link-tag__external-icon hl__link-tag__external-icon--white"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-906 -1005)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M923.78 1022.78V1015H926v7.78c0 1.22-1 2.22-2.22 2.22h-15.56c-1.23 0-2.22-1-2.22-2.22v-15.56c0-1.22.99-2.22 2.22-2.22H916v2.22h-7.78v15.56zm-5.71-17.78H926v7.93h-2.27v-4.07L912.6 1020l-1.6-1.6 11.14-11.13h-4.07z"
  })))))))));
};
OverlayPromo.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = OverlayPromo;

},{"prop-types":"prop-types","react":"react"}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _image = _interopRequireDefault(require("../../01-atoms/media/image.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  title: (0, _propTypes.shape)({
    text: _propTypes.string.isRequired
  }).isRequired,
  level: _propTypes.number,
  collection_type: _propTypes.string.isRequired,
  subText: _propTypes.string,
  description: _propTypes.string,
  image: _propTypes.object,
  link: (0, _propTypes.shape)({
    href: _propTypes.string.isRequired,
    info: _propTypes.string
  }).isRequired,
  id: _propTypes.string
};
var createMarkup = function createMarkup(rawText) {
  return {
    __html: rawText
  };
};
var teaserLink = function teaserLink(props) {
  var link = props.link,
    image = props.image,
    title = props.title,
    collection_type = props.collection_type,
    description = props.description,
    subText = props.subText,
    id = props.id;
  var level = props.level ? props.level : 2;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__teaser-link"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__teaser-link__container"
  }, image && image.src && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__teaser-link__image"
  }, /*#__PURE__*/_react["default"].createElement(_image["default"], image)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__teaser-link__details"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__teaser-link__eyebrow"
  }, collection_type), level === 2 && /*#__PURE__*/_react["default"].createElement("h2", {
    className: "hl__teaser-link__title"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: link.href
  }, title.text, collection_type === "website" && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__link-tag__external-icon"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-906 -1005)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M923.78 1022.78V1015H926v7.78c0 1.22-1 2.22-2.22 2.22h-15.56c-1.23 0-2.22-1-2.22-2.22v-15.56c0-1.22.99-2.22 2.22-2.22H916v2.22h-7.78v15.56zm-5.71-17.78H926v7.93h-2.27v-4.07L912.6 1020l-1.6-1.6 11.14-11.13h-4.07z"
  }))))))), level === 3 && /*#__PURE__*/_react["default"].createElement("h3", {
    className: "hl__teaser-link__title"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: link.href
  }, title.text, collection_type === "website" && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__link-tag__external-icon"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-906 -1005)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M923.78 1022.78V1015H926v7.78c0 1.22-1 2.22-2.22 2.22h-15.56c-1.23 0-2.22-1-2.22-2.22v-15.56c0-1.22.99-2.22 2.22-2.22H916v2.22h-7.78v15.56zm-5.71-17.78H926v7.93h-2.27v-4.07L912.6 1020l-1.6-1.6 11.14-11.13h-4.07z"
  }))))))), subText && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__teaser-link__sub-text"
  }, subText), description && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__teaser-link__description",
    dangerouslySetInnerHTML: createMarkup(description)
  }))));
};
teaserLink.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = teaserLink;

},{"../../01-atoms/media/image.jsx":3,"prop-types":"prop-types","react":"react"}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactMasonryComponent = _interopRequireDefault(require("react-masonry-component"));
var _ramda = _interopRequireDefault(require("ramda"));
var _overlayPromo = _interopRequireDefault(require("../../02-molecules/teasers/overlay-promo.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import PatternCta             from "../../02-molecules/text/pattern-cta.jsx";
var MasonryPromo = exports["default"] = /*#__PURE__*/function (_Component) {
  function MasonryPromo() {
    var _this;
    _classCallCheck(this, MasonryPromo);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MasonryPromo, [].concat(args));
    _defineProperty(_this, "renderItems", function (items) {
      return items.map(function (item) {
        var promo = _ramda["default"].assoc("title", item.title.text, item);
        promo.image = promo.card_image;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "hl__masonry-promo__item hl__masonry-promo__item--".concat(item.cardType),
          key: promo.id
        }, /*#__PURE__*/_react["default"].createElement(_overlayPromo["default"], promo));
      });
    });
    return _this;
  }
  _inherits(MasonryPromo, _Component);
  return _createClass(MasonryPromo, [{
    key: "render",
    value: function render() {
      var results = this.props.results;
      var masonryOptions = {
        columnWidth: ".hl__masonry-promo__sizing",
        itemSelector: ".hl__masonry-promo__item",
        percentPosition: true
      };
      return /*#__PURE__*/_react["default"].createElement("section", {
        className: "hl__masonry-promo"
      }, /*#__PURE__*/_react["default"].createElement(_reactMasonryComponent["default"], {
        className: "hl__masonry-promo__container" // default ''
        ,
        elementType: "section" // default 'div'
        ,
        options: masonryOptions // default {}
        ,
        disableImagesLoaded: false // default false
        ,
        updateOnEachImageLoad: false // default false and works only if disableImagesLoaded is false
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__masonry-promo__sizing",
        "aria-hidden": "true"
      }), this.renderItems(results)));
    }
  }]);
}(_react.Component);
_defineProperty(MasonryPromo, "propTypes", {
  results: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string.isRequired,
    title: (0, _propTypes.shape)({
      text: _propTypes.string.isRequired
    }).isRequired,
    cardType: _propTypes.string,
    card_image: _propTypes.object
  }))
});

},{"../../02-molecules/teasers/overlay-promo.jsx":14,"prop-types":"prop-types","ramda":"ramda","react":"react","react-masonry-component":"react-masonry-component"}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _teaserLink = _interopRequireDefault(require("../../02-molecules/teasers/teaser-link.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var propTypes = {
  results: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string
  })).isRequired
};
var TeaserGrid = function TeaserGrid(props) {
  var renderList = function renderList(items) {
    return items.map(function (item, i) {
      return /*#__PURE__*/_react["default"].createElement(_teaserLink["default"], _extends({
        key: item.id
      }, item));
    });
  };
  var results = props.results;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "hl__teaser-grid hl__teaser-grid--double"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__teaser-grid__container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__teaser-grid__grid"
  }, renderList(results))));
};
TeaserGrid.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = TeaserGrid;

},{"../../02-molecules/teasers/teaser-link.jsx":15,"prop-types":"prop-types","react":"react"}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
var _react = _interopRequireWildcard(require("react"));
var _ramda = _interopRequireDefault(require("ramda"));
var _queryString = _interopRequireDefault(require("query-string"));
var _filterBar = _interopRequireDefault(require("../../02-molecules/forms/filter-bar.jsx"));
var _filterToggles = _interopRequireDefault(require("../../02-molecules/forms/filter-toggles.jsx"));
var _sortByType = _interopRequireDefault(require("../../02-molecules/forms/sort-by-type.jsx"));
var _teaserGrid = _interopRequireDefault(require("../../03-organisms/lists/teaser-grid.jsx"));
var _masonryPromo = _interopRequireDefault(require("../../03-organisms/lists/masonry-promo.jsx"));
var _button = _interopRequireDefault(require("../../01-atoms/buttons/button.jsx"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CollectionDirectoryApp = exports["default"] = /*#__PURE__*/function (_Component) {
  function CollectionDirectoryApp(props) {
    var _this;
    _classCallCheck(this, CollectionDirectoryApp);
    _this = _callSuper(this, CollectionDirectoryApp, [props]);
    /********** Data Fetching ***************/
    // optional loadMore boolean is used to append or replace the existing results
    _defineProperty(_this, "fetchResults", function () {
      var loadMore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (loadMore) {
        _this.page++;
      } else {
        _this.page = 0;
      }
      var activeFilters = Object.assign({
        page: _this.page,
        _format: "json"
      }, _this.queryString);
      _this.$ajaxResults.abort();
      _this.$ajaxResults = _jquery["default"].ajax({
        url: "".concat(_this.props.requestUrl, "/api/v1/collections"),
        // cache: false,
        data: activeFilters
      });
      _this.$ajaxResults.done(function (data) {
        var currentResults = _this.state.results;
        var newResults = {
          totalCount: data.results.totalCount || 0,
          items: []
        };
        if (typeof data.results.items === "undefined" || data.results.items.length === 0) {
          if (!loadMore) {
            _this.setState({
              results: newResults
            });
          }
          return;
        }
        var newItems = _this.parseResultItems(data.results.items, true);
        if (loadMore) {
          newResults.items = currentResults.items.concat(newItems);
        } else {
          newResults.items = newItems;
        }
        _this.setState({
          results: newResults
        });
      }).fail(function (xhr, status, error) {
        console.warn("failed to fetch results");
        var results = {
          totalCount: 0,
          items: []
        };
        _this.setState({
          results: results
        });
      });
    });
    /********** End Data Fetching ***************/
    /********** Data Manipulation ***************/
    _defineProperty(_this, "parseResultItems", function (data) {
      var filters = _this.state.filters;
      return data.map(function (item, i) {
        return {
          id: item.id || "".concat(i),
          cardType: item.card_type,
          title: {
            text: item.title
          },
          collection_type: item.collection_type,
          subText: item.summary,
          subTitle: item.summary,
          description: "",
          link: {
            href: item.url,
            info: "Learn more about the '".concat(item.title, "' collection")
          },
          card_image: item.card_image,
          image: item.list_image
        };
      });
    });
    _defineProperty(_this, "initializeFilters", function (filters) {
      var params = _this.queryString;
      if (params.collectionName && filters.collectionName.items.length) {
        filters.collectionName.items[0].value = params.collectionName;
      }
      return filters;
      function markItem(param, filterItems) {
        param.forEach(function (paramValue) {
          var filterIndex = filterItems.findIndex(function (item) {
            return item.value === paramValue;
          });
          if (filterItems[filterIndex]) {
            filterItems[filterIndex].checked = true;
          }
        });
        return filterItems;
      }
    });
    // function takes two optional values
    // the url parameter and the value it should equal
    // if neither a parameter or value are passed,
    // we assume the queryString has been updated else where
    // and we just need to reset the url
    _defineProperty(_this, "updateUrl", function (param) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      // if a parameter and a value are passed add the new value
      if (param && value) {
        _this.queryString[param] = value;
      }
      // if a parameter is passed with a value remove the parameter
      if (param && (value === null || value.length === 0)) {
        delete _this.queryString[param];
      }
      var stringifiedQueries = _queryString["default"].stringify(_this.queryString);
      var newUrl = window.location.origin + window.location.pathname + "?" + stringifiedQueries;
      window.history.replaceState({
        path: newUrl
      }, "", newUrl);
    });
    /********** End Data Manipulation ***************/
    /********** Event Handlers ***************/
    _defineProperty(_this, "handleLoadMore", function () {
      _this.fetchResults(true);
    });
    // when search terms are changed
    _defineProperty(_this, "onKeywordChange", function (event) {
      var filters = Object.assign({}, _this.state.filters);
      var value = event.target.value;
      filters.collectionName.items[0].value = value;
      _this.updateUrl(filters.collectionName.param, value);
      _this.setState({
        filters: filters
      });
      if (value.length > 1 || value.length === 0) {
        // fetch results
        _this.fetchResults();
      }
    });
    //when a toggle is clicked
    _defineProperty(_this, "handleToggleChange", function (index) {
      var toggleView = Object.assign({}, _this.state.toggleView);
      toggleView.activeFilter = index;
      _this.updateUrl("active_filter", index);
      _this.setState({
        toggleView: toggleView
      });

      // fetch results -- this would cause a new surprise to appear when you toggle between views
      // this.fetchResults();
    });
    //when a sort filter is clicked
    _defineProperty(_this, "handleSortChange", function (index) {
      var sortItems = Object.assign({}, _this.state.sortItems);
      sortItems.activeFilter = index;
      _this.updateUrl("sort_by", index);

      // if random clicked
      if (index == "random") {
        var cache = Math.floor(Math.random() * 10000 + 1);
        _this.updateUrl("items_per_page", "1");
        _this.updateUrl("cache", cache);
        _this.updateUrl("sort_order", "");
      }

      // if newest clicked
      if (index == "created") {
        _this.updateUrl("items_per_page", "");
        _this.updateUrl("cache", "");
        _this.updateUrl("sort_order", "DESC");
      }

      // if a-z clicked
      if (index == "title") {
        _this.updateUrl("items_per_page", "");
        _this.updateUrl("cache", "");
        _this.updateUrl("sort_order", "ASC");
      }
      _this.setState({
        sortItems: sortItems
      });

      // fetch results
      _this.fetchResults();
    });
    _this.page = 0;
    _this.$ajaxResults = _jquery["default"].ajax();
    _this.queryString = _queryString["default"].parse(location.search); // params in the url
    _this.emptyMessage = "Loading...";
    _this.state = {
      toggleView: {
        label: "Toggle Views",
        param: "toggle",
        activeFilter: "0",
        items: [{
          name: "masonry view",
          value: "0",
          label: "masonry",
          icon: "masonry",
          checked: true
        }, {
          name: "list view",
          value: "1",
          label: "list",
          icon: "list",
          checked: false
        }]
      },
      sortItems: {
        label: "Sort by type",
        activeFilter: "created",
        items: [{
          name: "sort_by",
          value: "random",
          label: "Surprise Me!",
          checked: false,
          icon: "gift"
        }, {
          name: "sort_by",
          value: "created",
          label: "Newest",
          checked: true
        }, {
          name: "sort_by",
          value: "title",
          label: "A-Z",
          checked: false
        }]
      },
      filters: {
        collectionName: {
          label: "Filter",
          placeholder: 'Try "Audubon" or "digital"',
          param: "keywords",
          expanded: true,
          hideAccordion: true,
          filterType: "keyword",
          onChange: _this.onKeywordChange,
          items: [{
            value: _this.queryString.keywords || ""
          }]
        }
      },
      results: {
        totalCount: 0,
        items: []
      }
    };
    return _this;
  }
  _inherits(CollectionDirectoryApp, _Component);
  return _createClass(CollectionDirectoryApp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      Promise.all([]).then(function (values) {
        var filters = Object.assign({}, _this2.state.filters);

        // mark filters found in the URL
        filters = _this2.initializeFilters(filters);

        // update state and render filters
        _this2.setState({
          filters: filters
        });

        // fetch results
        _this2.fetchResults();
        _this2.emptyMessage = "No Results";
      });
    }
  }, {
    key: "render",
    value: /********** End Event Handlers ***************/

    function render() {
      var assetsUrl = this.props.assetsUrl;
      var _this$state = this.state,
        filters = _this$state.filters,
        results = _this$state.results,
        sortItems = _this$state.sortItems,
        toggleView = _this$state.toggleView;
      var activeFilter = toggleView.activeFilter;
      var activeView = activeFilter === "0" ? "hl__filter-bar-directory__views--masonry" : "hl__filter-bar-directory__views--list";
      var button = {
        text: "Load More",
        theme: "secondary"
      };
      var filterArray = [filters.collectionName];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar-directory__app"
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: "hl__filter-bar-directory__views ".concat(activeView)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar-directory__views-container"
      }, /*#__PURE__*/_react["default"].createElement(_filterBar["default"], {
        assetsUrl: assetsUrl,
        title: "Filter",
        groups: filterArray
      }), /*#__PURE__*/_react["default"].createElement(_sortByType["default"], _extends({
        onChange: this.handleSortChange
      }, sortItems)), /*#__PURE__*/_react["default"].createElement(_filterToggles["default"], _extends({
        onChange: this.handleToggleChange
      }, toggleView)))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar-directory__container"
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: "hl__filter-bar-directory__results"
      }, activeFilter === "0" && results.items.length > 0 && /*#__PURE__*/_react["default"].createElement(_masonryPromo["default"], {
        results: results.items
      }), activeFilter === "1" && results.items.length > 0 && /*#__PURE__*/_react["default"].createElement(_teaserGrid["default"], {
        results: results.items
      }), results.items.length === 0 && /*#__PURE__*/_react["default"].createElement("span", {
        className: "hl__filter-bar-directory__no-results"
      }, this.emptyMessage), results.items && results.items.length < results.totalCount && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar-directory__load-more"
      }, /*#__PURE__*/_react["default"].createElement(_button["default"], _extends({
        handleClick: this.handleLoadMore
      }, button))))));
    }
  }]);
}(_react.Component);
_defineProperty(CollectionDirectoryApp, "propTypes", {
  requestUrl: _propTypes.string.isRequired,
  assetsUrl: _propTypes.string.isRequired
});

},{"../../01-atoms/buttons/button.jsx":1,"../../02-molecules/forms/filter-bar.jsx":10,"../../02-molecules/forms/filter-toggles.jsx":11,"../../02-molecules/forms/sort-by-type.jsx":12,"../../03-organisms/lists/masonry-promo.jsx":16,"../../03-organisms/lists/teaser-grid.jsx":17,"jquery":"jquery","prop-types":"prop-types","query-string":"query-string","ramda":"ramda","react":"react"}],19:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _filterBarDirectoryCollectionApp = _interopRequireDefault(require("./filter-bar-directory-collection-app.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var el = document.querySelector(".js-collection-directory-app");
if (el) {
  var props = {
    requestUrl: el.getAttribute("data-request-url"),
    assetsUrl: el.getAttribute("data-assets-url")
  };
  (0, _reactDom.render)(/*#__PURE__*/_react["default"].createElement(_filterBarDirectoryCollectionApp["default"], props), el);
}

},{"./filter-bar-directory-collection-app.jsx":18,"react":"react","react-dom":"react-dom"}],20:[function(require,module,exports){
"use strict";

var _filterBarDirectoryCollection = _interopRequireDefault(require("../_patterns/04-templates/base/filter-bar-directory-collection.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }

},{"../_patterns/04-templates/base/filter-bar-directory-collection.js":19}]},{},[20]);
